module.exports = __webpack_public_path__ + "static/media/plane(10).f62a3d42.PNG";